// File: src/hooks/useImageLoader.js
import { useState, useEffect } from 'react';

const useImageLoader = (folderName) => {
  const [imagePaths, setImagePaths] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!folderName) {
      setError('Nama folder tidak valid.');
      setLoading(false);
      return;
    }

    try {
      // Menggunakan require.context dengan mode recursive (true)
      // untuk memindai semua sub-folder di direktori 2025.
      const context = require.context(
        '../../assets/documents/jpg/ebooks/2025/',
        true,
        /\.(jpg|jpeg|png)$/
      );

      const allImageKeys = context.keys();

      // Memfilter kunci gambar hanya dari folder yang diminta
      const folderImageKeys = allImageKeys.filter(key => 
        key.startsWith(`./${folderName}/`)
      );

      // Jika folder tidak ditemukan, set error
      if (folderImageKeys.length === 0) {
        throw new Error(`Folder "${folderName}" tidak ditemukan atau kosong.`);
      }

      // Logika pengurutan
      folderImageKeys.sort((a, b) => {
        const matchA_start = a.match(/^.\/(\d+)-/);
        const matchB_start = b.match(/^.\/(\d+)-/);
        const matchA_end = a.match(/-(\d+)\./);
        const matchB_end = b.match(/-(\d+)\./);

        let numA, numB;
        if (matchA_start) {
          numA = parseInt(matchA_start[1]);
        } else if (matchA_end) {
          numA = parseInt(matchA_end[1]);
        } else {
          numA = 0;
        }
        
        if (matchB_start) {
          numB = parseInt(matchB_start[1]);
        } else if (matchB_end) {
          numB = parseInt(matchB_end[1]);
        } else {
          numB = 0;
        }
        return numA - numB;
      });

      const urls = folderImageKeys.map(context);
      setImagePaths(urls);
      setLoading(false);
    } catch (e) {
      console.error("Gagal memuat gambar:", e);
      setError(e.message || "Terjadi kesalahan saat memuat gambar.");
      setLoading(false);
    }
  }, [folderName]);

  return { imagePaths, loading, error };
};

export default useImageLoader;